export const ACTIONS_COLUMN = 'actions';
